import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setBreadCrumb } from "../../../../store/userSlice";
import { useState } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import DependentPaymentSummaryFirst from "./dependentPaymentSummary";
import DependentPaymentSummarySecond from "./dependentPaymentSummary2";
import { setWorkflowIndex } from "../../../../store/userSlice";
import { useNavigate } from "react-router-dom";
import { getInsuranceDependentData } from "../../../../store/Api/InsuranceDependent";
import { getDependentSummary } from "../../../../store/Api";
import nodeinstance from "../../../../nodeInstance";

export default function dependentPayment() {
  const InsuranceDependentDataList = useSelector(
    (state) => state.insuranceDependentData
  );
  // const dependentDetails = useSelector(
  //   (state) => state.dependentSummaryData
  // );

  const [dependentDetails, SetDependentDetails] = useState();
  const [action, setAction] = useState(false);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const [index, setIndex] = useState(2);
  const [searchWords, setSearchWords] = React.useState([]);
  const [buttonIndex, setButtonIndex] = useState(2);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const titleBorder = [
    { label: "DEPENDENT Payment", link: "/dashboard/dependent-payment" },
  ];
  const getData = async () => {
    const params =
    buttonIndex === 0
      ? "OPS2"
      : buttonIndex === 1
        ? "OPS1"
        : buttonIndex === 2
          ? "FINANCE"
          : buttonIndex === 3
            ? "APPLY INSURANCE"
            : "OPS2";
    try {
      const response = await nodeinstance.get(
        `insurance-dependent/getDependentByStatus/${params}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        SetDependentDetails(response?.data);
      }
    } catch (error) {
      console.log("error.......", error);
    }
  };
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    dispatch(getInsuranceDependentData(token));
    // dispatch(getDependentSummary(token));
    getData();
  }, []);

  function handleIndex(numb) {
    console.log("..........numb.......",numb)
    dispatch(setWorkflowIndex(numb));
    if (numb === 1) {
      setButtonIndex(numb)
      navigate("/dashboard/dependent-addition");
    } else if (numb === 2) {
      setButtonIndex(numb)
      navigate("/dashboard/dependent-payment");
    } else if (numb === 3) {
      setButtonIndex(numb)
      navigate("/dashboard/Apply_insurance");
    } else {
      navigate("/dashboard/dependent-addition");
    }
  }

  const [newIndex, setnewIndex] = useState(1);

  const updateData = () => {
    dispatch(getInsuranceDependentData(token));
    // dispatch(getDependentSummary(token));
    getData();
  };
  console.log("dependentDetails...............", dependentDetails);
  return (
    <div className="mt-5 w-[95%] mx-auto">
      <div className="flex ">
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleIndex(0)}
        >
          OPS 2
        </button>
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleIndex(1)}
        >
          OPS 1
        </button>
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 2 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleIndex(2)}
        >
          FINANCE
        </button>
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 3 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleIndex(3)}
        >
          APPLY INSURANCE
        </button>
      </div>

      <div className="mt-2 ">
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${newIndex == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => setnewIndex(1)}
        >
          DEPENDENT ADDITION APPROVAL
        </button>
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${newIndex == 2 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => setnewIndex(2)}
        >
          {newIndex === 2 ? "INSURANCE VENDOR PAYMENT" : "VENDOR PAYMENT"}
        </button>
      </div>

      {newIndex === 1 ? (
        <DependentPaymentSummaryFirst
          list={dependentDetails}
          loading={loading}
          titles={[
            "S.NO",
            "EMP NAME",
            "EMP ID",
            "GENDER",
            "NATIONALITY",
            "ACTUAL PROFESSION",
            "CLIENT NAME",
            "IQAMA NUMBER",
            "IQAMA EXPIRY DATE",
            "PROJECT NAME",
            "INSURANCE CLASS",
            "ACTION",
          ]}
          token={token}
          setAction={setAction}
          action={action}
          updateData={updateData}
          setnewIndex={setnewIndex}
        />
      ) : (
        <DependentPaymentSummarySecond
          list={dependentDetails}
          loading={loading}
          titles={[
            "S.NO",
            "DEPENDENT NAME",
            "DATE OF BIRTH",
            "DEPENDENT IQAMA NUMBER",
            "RELATION",
            "CLASS",
            "GENDER",
            "HEAD OF FAMILY",
            "INSURANCE APPLY DATE",
            "AMOUNT PAID",
            "INVOICE NUMBER",
            "ACTION",
          ]}
          token={token}
          setAction={setAction}
          action={action}
          updateData={updateData}
        />
      )}
    </div>
  );
}
